import Hero from './components/Hero';
import Features from './components/Features';
import ProjectManagement from './components/ProjectManagement';
import AIAssistant from './components/AIAssistant';
import Automation from './components/Automation';
import Analytics from './components/Analytics';
import Workflow from './components/Workflow';
import CTA from './components/CTA';
// @ts-ignore
import { useAutoSEO } from '../../hooks/useSEOFromRoute';

export default function StackwayCRMPage() {
  // Auto fetch SEO from database based on route
  useAutoSEO();

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Features />
      <ProjectManagement />
      <AIAssistant />
      <Automation />
      <Analytics />
      <Workflow />
      <CTA />
    </div>
  );
}
